import { Link } from "react-router-dom";
import { PenLine, PhoneCall } from "lucide-react";
import { GoldBadge, Reveal } from "@/components/shared";

export default function FoundersNote() {
  return (
    <section data-testid="founders-note" className="max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-28">
      <Reveal>
        <div className="card-pain relative overflow-hidden p-8 sm:p-12 lg:p-16">
          <div className="absolute inset-x-0 top-0 h-[2px] bg-gradient-to-r from-transparent via-amber-500 to-transparent" />
          <div className="max-w-3xl">
            <GoldBadge testId="founders-note-badge">A Note From The Founder</GoldBadge>
            <h2 className="font-display mt-5 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-50">
              Drop the mask. <span className="gold-text-gradient">You are not alone.</span>
            </h2>
            <div className="h-[2px] w-16 bg-gradient-to-r from-amber-400 via-amber-600 to-transparent my-5" />
            <div className="space-y-5 text-base sm:text-lg leading-relaxed text-slate-300">
              <p>
                I know firsthand what it means to face the start of a new week while navigating
                mental health struggles. I live this journey every single day, and I continue to
                fight — both for my own well-being and for everyone in our community who feels
                unseen.
              </p>
              <p>
                Behind Every Mask, there is a silent battle. So many of us put on a brave face to
                face the world, hiding the exhaustion and pain underneath. But you do not have to
                carry that weight alone, and you do not have to pretend to be okay.
              </p>
              <p>
                True advocacy requires real action and reliable resources. That is why we are
                incredibly proud to partner with Harmony Harbour Mental Health Services — a deeply
                professional crisis team ready to support you when things get heavy. Together, we
                make sure you have immediate access to help whenever you need it.
              </p>
              <p className="font-display text-lg sm:text-xl italic text-amber-200/95">
                If you are struggling today, please drop the mask and reach out. We are here, and
                you are not alone.
              </p>
            </div>
            <div className="mt-8 flex items-center gap-4">
              <span className="flex items-center justify-center h-11 w-11 rounded-full bg-[#1D4ED8]/20 border border-amber-500/30">
                <PenLine className="h-5 w-5 text-amber-400" />
              </span>
              <div>
                <p className="font-display text-base sm:text-lg font-semibold text-slate-50">
                  Ronald Waters
                </p>
                <p className="text-xs sm:text-sm text-slate-400">
                  Founder & CEO — People Against Intentional Neglect (P.A.I.N.)
                </p>
              </div>
            </div>
            <Link
              to="/contact"
              data-testid="founders-note-cta"
              className="btn-royal mt-8 inline-flex items-center gap-2 rounded-md px-6 py-3 text-sm font-semibold text-white"
            >
              <PhoneCall className="h-4 w-4" />
              Reach Out Securely
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
